import { child, get, push as firebasePush, ref, set } from "firebase/database";

import { database } from "../config/firebase";

export type UserSuggestion = {
  uid: string;
  title: string;
  description: string;
  createdAt: string;
  fromUser?: string;
  userId?: string;
};

async function submitUserSuggestion(params: {
  userId: string;
  email?: string;
  title: string;
  description: string;
}): Promise<void> {
  if (!database) throw new Error("Database não configurado");
  const suggestionsRef = child(ref(database), "suggestions");
  const newRef = firebasePush(suggestionsRef);
  const uid = newRef.key;
  if (!uid) throw new Error("Falha ao gerar id");

  const payload: UserSuggestion = {
    uid,
    title: params.title.trim(),
    description: params.description.trim(),
    createdAt: new Date().toISOString(),
    fromUser: params.email || params.userId,
    userId: params.userId,
  };

  await set(newRef, payload);
  await set(
    child(ref(database), `userSuggestions/${params.userId}/${uid}`),
    payload
  );
}

export async function listUserSuggestions(
  userId: string
): Promise<UserSuggestion[]> {
  if (!database) throw new Error("Database não configurado");
  if (!userId) return [];

  const snapshot = await get(child(ref(database), `userSuggestions/${userId}`));
  if (!snapshot.exists()) return [];

  const items: UserSuggestion[] = [];
  snapshot.forEach((snap) => {
    const val = snap.val() as UserSuggestion | null;
    if (val) items.push(val);
  });

  return items.sort((a, b) =>
    (b.createdAt || "").localeCompare(a.createdAt || "")
  );
}

export default submitUserSuggestion;
